import React from 'react';

export default function ShowDayPlanning(props) {
    
    const shedules = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];
    const hourly = [8, 12, 14, 18];
    const reservation = [
        {indexH: 8, status: 'Unavailable', validity: 1},
        {indexH: 8.5, status: 'Available', validity: 0},
        {indexH: 9, status: 'Unavailable', validity: 1},
        {indexH: 9.5, status: 'Unavailable', validity: 1},
        {indexH: 10, status: 'Available', validity: 0},
        {indexH: 10.5, status: 'Available', validity: 0},
        {indexH: 11, status: 'Available', validity: 0},
        {indexH: 11.5, status: 'Unavailable', validity: 1},
        {indexH: 14, status: 'Available', validity: 0},
        {indexH: 14.5, status: 'Available', validity: 0},
        {indexH: 15, status: 'Unavailable', validity: 1},
        {indexH: 15.5, status: 'Unavailable', validity: 1},
        {indexH: 16, status: 'Available', validity: 0},
        {indexH: 16.5, status: 'Unavailable', validity: 1},
        {indexH: 17, status: 'Available', validity: 0},
        {indexH: 17.5, status: 'Available', validity: 0},
    ]
    return (
        <div className="open_day_container">
            <div className="open_day_content" id="showDayPlanningContent">
                <div
                    className="closeBut"
                    onClick={() => {
                        document.querySelector('#showDayPlanningContent').style.animation =
                            'hide_demo_message_container 0.6s ease-in-out';
                        setTimeout(() => props.setOpenDay({...props.openDay, disp: false}), 350);
                        }}>
                    <img
                      src={process.env.PUBLIC_URL + '/icons/go_back_70x70.ico'}
                      width="50"
                      height="50"
                      alt="go back" />
                </div>
                <div>
                    <span className="open_day_title">
                        {props.openDay.dayName + ' ' +
                        props.openDay.day + ' ' +
                        props.openDay.month + ' ' +
                        props.openDay.year}
                    </span>
                </div>
                <div>
                    <span className="open_day_notice">
                        Book your appointment
                    </span>
                </div>
                <div className="hourlySpace">
                    <div key="hourlyGroup1" className="hourlyGroup1">
                        {shedules.map((t, index) => {
                        var index_G = index
                        if (index_G >= hourly[0] && index_G <= hourly[1] - 1)
                        return (
                            <div key={index + 'hh'}>
                            <div key={index + 'pmh'} className="hourly">
                                <span style={{width: '60px'}}>{index_G + 'h'}</span>
                                <span>
                                {reservation.map((res, index) => {
                                    if (res.indexH === index_G) {
                                    return (
                                        <div
                                        key={index + 'sh'}
                                        className={res.status === 'Available' ? 'hourlyFree' : 'hourlyBusy'}
                                        onClick={() => {
                                            if (res.status === 'Available') {
                                            props.setBookForm({
                                                ...props.sbookForm,
                                                disp: true,
                                                day: props.openDay.day + ' ' + props.openDay.month + ' ' + props.openDay.year,
                                                hour: index_G + 'h',
                                            })
                                            }}
                                        }
                                        style={{
                                            width: '200px',
                                            textAlign: 'center',
                                            background: res.status === 'Unavailable' && res.validity === 1
                                            ? '#F05E5E'
                                            : 'lightgreen',
                                        }}>
                                        <span>{res.status}</span>
                                        </div>
                                    )
                                    }    
                                })}
                                </span>
                            </div>
                            <div key={index + 'pmh30'} className="hourly">
                                <span style={{width: '60px'}}>{index + 'h30'}</span>
                                <span>
                                {reservation.map((res, index) => {
                                    if (res.indexH === index_G + 0.5) {
                                    return (
                                        <div
                                        key={index + 'sh.5'}
                                        className={res.status === 'Available' ? 'hourlyFree' : 'hourlyBusy'}
                                        onClick={() => {
                                            if (res.status === 'Available') {
                                                props.setBookForm({
                                                ...props.bookForm,
                                                disp: true,
                                                day: props.openDay.day + ' ' + props.openDay.month + ' ' + props.openDay.year,
                                                hour: index_G + 'h30',
                                            })
                                            }}
                                            }
                                        style={{
                                        width: '200px',
                                        textAlign: 'center',
                                        background: res.status === 'Unavailable' && res.validity === 1
                                            ? '#F05E5E'
                                            : 'lightgreen',
                                        }}>
                                        <span>{res.status}</span>
                                        </div>
                                    )
                                    }    
                                })}
                                </span>
                            </div>
                            </div>
                        )
                        })}
                    </div>
                    
                    {shedules.map((t, index) => (index === hourly[1] + 1 && (<div key={index + 's'}><br></br></div>)))}

                    <div key="hourlyGroup2" className="hourlyGroup1">
                        {shedules.map((t, index) => {
                        var index_G = index
                        if (index >= hourly[2] && index < hourly[3])
                        return (
                            <div key={index + 'hh2'}>
                            <div key={index + 'amh'} className="hourly">
                                <span style={{width: '60px'}}>{index_G + 'h'}</span>
                                <span>
                                {reservation.map((res, index) => {
                                    if (res.indexH === index_G) {
                                    return (
                                        <div
                                        className={res.status === 'Available' ? 'hourlyFree' : 'hourlyBusy'}
                                        key={index + 'ssh'}
                                        onClick={() => {
                                            if (res.status === 'Available') {
                                                props.setBookForm({
                                                    ...props.bookForm,
                                                    disp: true,
                                                    day: props.openDay.day + ' ' + props.openDay.month + ' ' + props.openDay.year,
                                                    hour: index_G + 'h',
                                            })
                                            }}
                                            }
                                        style={{
                                            width: '200px',
                                            textAlign: 'center',
                                            background: res.status === 'Unavailable' && res.validity === 1
                                            ? '#F05E5E'
                                            : 'lightgreen',
                                            }}>
                                        <span>{res.status}</span>
                                        </div>
                                    )
                                    }    
                                })}
                                </span>
                            </div>
                            <div key={index + 'amh30'} className="hourly">
                                <span style={{width: '60px'}}>{index + 'h30'}</span>
                                <span>
                                {reservation.map((res, index) => {
                                    if (res.indexH === index_G + 0.5) {
                                    return (
                                        <div
                                        key={index + 'ssh.5'}
                                        className={res.status === 'Available' ? 'hourlyFree' : 'hourlyBusy'}
                                        onClick={() => {
                                            if (res.status === 'Available') {
                                                props.setBookForm({
                                                    ...props.bookForm,
                                                    disp: true,
                                                    day: props.openDay.day + ' ' + props.openDay.month + ' ' + props.openDay.year,
                                                    hour: index_G + 'h30',
                                            })
                                            }}
                                            }
                                        style={{
                                        width: '200px',
                                        textAlign: 'center',
                                        background: res.status === 'Unavailable' && res.validity === 1
                                            ? '#F05E5E'
                                            : 'lightgreen',
                                        }}>
                                        <span>{res.status}</span>
                                        </div>
                                    )
                                    }    
                                })}
                                </span>
                            </div>
                            </div>
                        )
                        })}
                    </div>
                </div>
            </div>
        </div>
    )
}
